export enum AlertContextEnum {
  Global = 'GLOBAL',
  CalculationDeleted = 'CALCULATION_DELETED',
  Calculations = 'CALCULATIONS',
  ClientQuestionnaireDeleted = 'CLIENT_QUESTIONNAIRE_DELETE',
}